// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"495":"6c5f10ff","756":"5c5d6a0e"}[chunkId] + ".chunk.css";
};